<template>
    <!-- <PageLoading v-if="isLoading" /> -->
    <div class="main-wrap contact-page">
        <div class="contact-form row q-col-gutter-x-lg">
            <div class="col-12 col-md-6 q-pb-lg">
                <div class="information-map text-left">
                    <h5>{{ luandaAddress.name }}</h5>
                    <br />
                    <p class="q-mb-sm">
                        <b>{{ $t('general.address') }}: </b>
                        {{ luandaAddress.address }}
                    </p>
                    <p class="q-mb-sm">
                        <b>{{ $t('general.website') }}: </b>
                        {{ luandaAddress.website }}
                    </p>
                    <p class="q-mb-sm">
                        <b>{{ $t('general.email') }}: </b>
                        {{ luandaAddress.email }}
                    </p>
                    <p class="q-mb-sm">
                        <b>{{ $t('general.phone') }}: </b>
                        {{ luandaAddress.telephone }}
                    </p>
                </div>
                <div class="mapouter q-mt-sm">
                    <div class="gmap_canvas">
                        <iframe
                            id="gmap_canvas"
                            width="600"
                            height="500"
                            src="https://maps.google.com/maps?q=-8.777734851222883,%2013.356774864704644&t=&z=13&ie=UTF8&iwloc=&output=embed"
                            frameborder="0"
                            scrolling="no"
                            marginheight="0"
                            marginwidth="0"
                        ></iframe>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 q-pb-lg">
                <div class="information-map text-left">
                    <h5>{{ sumbeAddress.name }}</h5>
                    <br />
                    <p class="q-mb-sm">
                        <b>{{ $t('general.address') }}: </b>
                        {{ sumbeAddress.address }}
                    </p>
                    <p class="q-mb-sm">
                        <b>{{ $t('general.website') }}: </b>
                        {{ sumbeAddress.website }}
                    </p>
                    <p class="q-mb-sm">
                        <b>{{ $t('general.email') }}: </b>
                        {{ sumbeAddress.email }}
                    </p>
                    <p class="q-mb-sm">
                        <b>{{ $t('general.phone') }}: </b>
                        {{ sumbeAddress.telephone }}
                    </p>
                </div>
                <div class="mapouter q-mt-sm">
                    <div class="gmap_canvas">
                        <iframe
                            id="gmap_canvas"
                            width="600"
                            height="500"
                            src="https://maps.google.com/maps?q=-11.299255429371847,%2013.84209705109781&t=&z=13&ie=UTF8&iwloc=&output=embed"
                            frameborder="0"
                            scrolling="no"
                            marginheight="0"
                            marginwidth="0"
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
        <h1 class="text-capitalize q-mb-lg">{{ $t('general.contact') }}</h1>
        <ContactForm class="q-my-lg" :user="user" />
    </div>
</template>

<script>
// import PageLoading from '@/components/PageLoading'
import ContactForm from '@/components/ContactForm'
import store from '@/store'

export default {
    name: 'Contact',

    components: {
        // PageLoading,
        ContactForm,
    },

    data () {
        return {
            luandaAddress: {
                name: 'CFMA Luanda (Cacuaco)',
                address:
                    'Província de Luanda, Município de Cacuaco, Estrada de Cacuaco Km 09 s/n, Bairro Hotangana',
                website: 'http://cfma.sonangol.co.ao',
                email: 'cfma.angola@gmail.com',
                telephone: '22 66 94 106/07',
            },
            sumbeAddress: {
                name: 'CFMA Sumbe',
                address: 'Província do Cuanza Sul, Município de Quicombo, no topo da escarpa transicional Norte/Sul a aproximadamente 2 quilómetros da costa do Atlântico, a 11 km do Sudoeste da cidade do Sumbe',
                website: 'http://cfma.sonangol.co.ao',
                email: 'cfma.angola@gmail.com',
                telephone: '',
            },
        }
    },

    computed: {
        user () {
            return store.getters['session/user']
        },
    },
}
</script>
